/* eslint-disable quotes */
import i18n from 'i18next';
import XHR from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// import i18nLib from 'handimap-react-lib/utils/i18n';
import translationEN from 'handimap-react-lib/i18n/en.json';
import translationES from 'handimap-react-lib/i18n/es.json';
import translationFR from 'handimap-react-lib/i18n/fr.json';
import translationENHerault from '../i18n/en.json';
import translationESHerault from '../i18n/es.json';
import translationFRHerault from '../i18n/fr.json';

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  es: {
    translation: translationES
  }
};

const options = {
  order: ['querystring', 'navigator'],
  lookupQuerystring: 'lng'
};

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(XHR)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: true,
    keySeparator: '.',  // to support nested translations
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
    detection: options,
    supportedLngs: ['fr', 'en', 'es'],
  });

i18n.addResourceBundle("en", "translation", translationENHerault, true, true);
i18n.addResourceBundle("fr", "translation", translationFRHerault, true, true);
i18n.addResourceBundle("es", "translation", translationESHerault, true, true);

export default i18n;